const prefix = (function () {
    const styles = window.getComputedStyle(document.documentElement, '');
    const pre = (Array.prototype.slice
        .call(styles)
        .join('')
        .match(/-(moz|webkit|ms)-/) ||
        (styles.OLink === '' && ['', 'o']))[1];
    return pre;
})();

export function isWebkit() {
    return prefix === 'webkit';
}
